import { render, staticRenderFns } from "./AlignShapeControls.vue?vue&type=template&id=8313a940&scoped=true"
import script from "./AlignShapeControls.vue?vue&type=script&lang=ts"
export * from "./AlignShapeControls.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./AlignShapeControls.vue?vue&type=style&index=0&id=8313a940&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "8313a940",
  null
  ,true
)

export default component.exports